// Tipos para o sistema de estados unificado do player
export type PlayerStatus = 
  | 'idle'                    // Pronto para ação
  | 'loading'                 // Adicionado estado de loading
  | 'loading-song'           // Carregando música individual
  | 'loading-playlist'       // Carregando playlist
  | 'transitioning'          // Mudando de música
  | 'navigating'             // Navegando para player
  | 'buffering'              // Carregando áudio
  | 'playing'                // Reproduzindo
  | 'paused'                 // Pausado
  | 'error'                  // Estado de erro
  | 'switching-context';     // Mudando contexto (categoria/jornada)

export type PlayerSubStatus = {
  isAudioLoading: boolean;
  isNetworkRequest: boolean;
  isCacheOperation: boolean;
  isUserInteraction: boolean;
};

export type PlayerState = {
  status: PlayerStatus;
  subStatus: PlayerSubStatus;
  lastAction: string;
  timestamp: number;
  error?: string;
};

// Ações permitidas por estado
export type PlayerAction = 
  | 'play-song'
  | 'play-category' 
  | 'play-playlist'
  | 'pause'
  | 'stop'
  | 'navigate'
  | 'switch-song'
  | 'reset'
  | 'next'
  | 'previous'
  | 'seek'
  | 'load-song'
  | 'load-playlist';

// Mapeamento de transições válidas
export const VALID_TRANSITIONS: Record<PlayerStatus, PlayerStatus[]> = {
  'idle': ['loading', 'playing', 'error'],
  'loading': ['playing', 'error', 'idle'],
  'playing': ['paused', 'buffering', 'error', 'transitioning'],
  'paused': ['playing', 'error', 'transitioning'],
  'error': ['idle', 'loading'],
  'buffering': ['playing', 'error'],
  'transitioning': ['playing', 'error', 'idle'],
  'loading-song': ['buffering', 'transitioning', 'error', 'idle'],
  'loading-playlist': ['buffering', 'transitioning', 'error', 'idle', 'playing'],
  'navigating': ['idle', 'playing', 'paused', 'error'],
  'switching-context': ['loading-playlist', 'transitioning', 'error', 'idle'],
};

export type PlayerEvent = 
  | 'play-start'
  | 'play-success'
  | 'play-failed'
  | 'pause-start'
  | 'pause-success'
  | 'pause-failed'
  | 'stop-start'
  | 'stop-success'
  | 'stop-failed'
  | 'next-start'
  | 'next-success'
  | 'next-failed'
  | 'previous-start'
  | 'previous-success'
  | 'previous-failed'
  | 'seek-start'
  | 'seek-success'
  | 'seek-failed'
  | 'load-start'
  | 'load-success'
  | 'load-failed'
  | 'user-stop'
  | 'emergency-reset'; 